<template>
    <div class="container">
        <div class="row text-center">
            <div class="col-lg-6 offset-lg-3 col-sm-6 offset-sm-3 col-12 p-3 error-main">
                <div class="row">
                    <div class="error_page col-lg-8 col-12 col-sm-10 offset-lg-2 offset-sm-1">
                        <i :class="['fa', message ? 'fa-exclamation-circle' : 'fa-lock']"></i>
                        <h1 class="m-0">{{ message ? 'Error' : '403' }}</h1>
                        <h6>{{ title }}</h6>
                        <p v-if="message">{{ message }}</p>
                        <p v-else>You don't have permission to access on this page</p>
                        <button @click="goBack" class="btn btn-primary mt-3">
                            Go Back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Layout from '@/Shared/Layout'

    export default {
        components: {},
        layout: Layout,
        props: {
            status: {
                type: Boolean,
                default: false
            },
            error: {
                type: Boolean,
                default: true
            },
            message: {
                type: String,
                default: ''
            }
        },
        computed: {
            title() {
                if (this.message) {
                    return this.error ? 'Error Occurred!' : 'Warning'
                }
                return 'Forbidden!'
            }
        },
        methods: {
            goBack() {
                window.history.back()
            }
        }
    }
</script>

<style>
    .error_page>i {
        font-size: 90px !important;
        color: var(--error-color, #dc3545);
        margin-top: 20px;
        padding-bottom: 20px;
    }

    .error_page>i.fa-lock {
        color: #5D6572;
    }

    .error-main h1 {
        font-weight: bold;
        color: #444444;
        font-size: 100px;
        text-shadow: 2px 4px 5px #6E6E6E;
    }

    .error-main h6 {
        color: #42494F;
        font-size: 1.25rem;
        margin-bottom: 1rem;
    }

    .error-main p {
        color: #9897A0;
        font-size: 1rem;
        white-space: pre-wrap;
        word-break: break-word;
    }

    .error_page.col-lg-8.col-12.col-sm-10.offset-lg-2.offset-sm-1 {
        margin-top: 89px;
    }

    .btn-primary {
        background-color: #007bff;
        border-color: #007bff;
        color: white;
        padding: 0.5rem 1.5rem;
        border-radius: 0.25rem;
        transition: all 0.3s ease;
    }

    .btn-primary:hover {
        background-color: #0056b3;
        border-color: #0056b3;
    }
</style>
